export default {
  title: 'Importar menu',
  master_title: 'Modo marca - Importar menu',
  buttons: {
    import: 'Importar',
  },
  toasts: {
    import: {
      pending:
        '⏳Como a importação pode demorar, fazemo-la em segundo plano. Verifique o menu do restaurante dentro de alguns minutos.',
    },
  },
};
